export default __webpack_public_path__ + "static/media/ShantiBG.d9d9e69c.webp";